export class OnboardUserRequest {

    constructor(public userName: string,
        public firstName: string,
        public lastName: string,
        public emailId: string,
        public phoneNumber: string,
        public systemType: string,
        public loginUrl: string,
        public redirectUrl: string,
        public applicationName: string
       
    ) {

    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/onboardingUserForgerock/onboard-user-request.ts
 **/